function validateEmailAddresses(addresses) {
  if (!addresses) {
    return null;
  }

  // return str with error or null
  const items = addresses.split(';');
  for (const item of items) {
    const address = item.trim();
    if (address === '') continue;
    if (address.includes(' ')) {
      return `Error: Invalid contact email address "${address}" can't contain spaces.`;
    }
    if (!address.includes('@')) {
      return `Error: Invalid contact email address "${address}", must contain "@".`;
    }
  }
  return null;
}

export default {
  validateEmailAddresses,
};
